// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1N9oe","cardBody":"card-module--cardBody--3ttU0","cardImage":"card-module--cardImage--1czdl"};